var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildSequenceLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 2.935H16M1 2.935H3.25M13.75 8.185H16M1 8.185H9.25M9.25 13.435H16M1 13.435H4.75M7.375 2.875C7.37151 3.37684 7.17468 3.85801 6.82545 4.21842C6.47622 4.57882 6.00148 4.79071 5.5 4.81C4.99852 4.79071 4.52378 4.57882 4.17455 4.21842C3.82532 3.85801 3.62849 3.37684 3.625 2.875C3.625 2.37772 3.82254 1.90081 4.17417 1.54917C4.52581 1.19754 5.00272 1 5.5 1C5.99728 1 6.47419 1.19754 6.82583 1.54917C7.17746 1.90081 7.375 2.37772 7.375 2.875ZM13.375 8.125C13.375 8.62228 13.1775 9.09919 12.8258 9.45083C12.4742 9.80246 11.9973 10 11.5 10C11.0027 10 10.5258 9.80246 10.1742 9.45083C9.82254 9.09919 9.625 8.62228 9.625 8.125C9.625 7.62772 9.82254 7.15081 10.1742 6.79918C10.5258 6.44754 11.0027 6.25 11.5 6.25C11.9973 6.25 12.4742 6.44754 12.8258 6.79918C13.1775 7.15081 13.375 7.62772 13.375 8.125ZM8.875 13.375C8.87151 13.8768 8.67468 14.358 8.32545 14.7184C7.97622 15.0788 7.50148 15.2907 7 15.31C6.49852 15.2907 6.02378 15.0788 5.67455 14.7184C5.32532 14.358 5.12849 13.8768 5.125 13.375C5.125 12.8777 5.32254 12.4008 5.67417 12.0492C6.02581 11.6975 6.50272 11.5 7 11.5C7.49728 11.5 7.97419 11.6975 8.32583 12.0492C8.67746 12.4008 8.875 12.8777 8.875 13.375Z",
    stroke: "#C8BCFF",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildSequenceLight);
export default __webpack_public_path__ + "static/media/build_sequence_light.5dd2bea27a26975f9f080c6d3e66edcb.svg";
export { ForwardRef as ReactComponent };